export default "__VITE_ASSET__0a7c2bfa__"